export default __webpack_public_path__ + "alberta-ic-send.014f5177029596a7f2f0.svg";